import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={32}
    height={32}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.098 27.763-1.292-1.526L25.723 17H2.452v-2h23.27L14.807 5.763l1.292-1.526L30 16 16.098 27.763Z"
    />
  </svg>
);
export default SvgIcArrowRight;
